import React, { Fragment } from 'react';
import { ConfigConsumer } from '../config-provider';
import classNames from 'classnames';
const FtLine = (props) => {
    const renderFtLine = ({ getPrefixCls }) => {
        const { prefixCls: customizePrefixCls, leftContent } = props;
        const prefixCls = getPrefixCls('line', customizePrefixCls);
        const content = leftContent.split('');
        const copyCls = classNames(prefixCls);
        const MaohaoElement = (props.maohao ? (<b>:</b>) : <Fragment></Fragment>);
        return <div className={copyCls}>
        <div className={`${copyCls}--left`} style={{ width: props.leftWidth, height: props.leftHeight }}>
            {content.map((item, index) => <b key={index}>{item}</b>)}
        </div>
        {MaohaoElement}
        <div className={`${copyCls}--right`}>
             {props.children}       
        </div>
    </div>;
    };
    return (<ConfigConsumer>{renderFtLine}</ConfigConsumer>);
};
FtLine.defaultProps = {
    leftWidth: '70px',
    leftHeight: '18px',
    maohao: true
};
export default FtLine;
